export default __webpack_public_path__ + "static/15-2653398b902d0255988e3185bfee27ea.png";